import request from '@/utils/request';

/**
 * 收益列表
 * @param { page: 页码, count： 一页显示多少条, startTime: 开始时间, endTime: 结束时间 } data 
 */
export function IncomeList(data) {
  return request({
    url: '/profit/list',
    method: 'post',
    data
  });
}

/**
 * 收益统计
 * @param { startTime: 开始时间, endTime: 结束时间 } data 
 */
export function IncomeCount(data) {
  return request({
    url: '/profit/count',
    method: 'post',
    data
  });
}